import { useEffect } from 'react';

import { Timeout } from '@utils/types';

export const useKeyboardSecret = ({
  shortcut,
  onSuccess,
}: {
  shortcut: string;
  onSuccess: () => void;
}) => {
  useEffect(() => {
    let to: Timeout;
    let input = '';

    const handleKeyDown = (e: KeyboardEvent) => {
      clearTimeout(to);
      input += e.key;

      if (input.includes(shortcut)) {
        onSuccess();
      }

      to = setTimeout(() => {
        input = '';
      }, 800);
    };
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [shortcut, onSuccess]);
};
